"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LateIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const LateIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 30 30" }),
    react_1.default.createElement("circle", { cx: "15", cy: "15", r: "15", fill: "white" }),
    react_1.default.createElement("g", { transform: "translate(-1,-1)" },
        react_1.default.createElement("path", { d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm6.89,17.45A1,1,0,0,1,22,20a.93.93,0,0,1-.45-.11l-6-3A1,1,0,0,1,15,16V7a1,1,0,0,1,2,0v8.38l5.45,2.73A1,1,0,0,1,22.89,19.45Z" }))));
exports.LateIcon = LateIcon;
exports.default = exports.LateIcon;
